import tx from "./data/txes.js";

const txes = tx.map((t) => {
  if (typeof t.Value === "string") {
    const value = parseFloat(t.Value.replace(",", ""));
    return { ...t, Value: value };
  } else {
    return t;
  }
});
const totalStakedUNIForAddresses = txes.filter(
  (tx) =>
    tx.To.toLowerCase() ===
      "0x8ec7466a5025ac26368bd8b8cfd2571f9bc0dc6f".toLowerCase() &&
    tx.TokenSymbol === "UNI-V2"
);

const totalWithdrawUNIForAddresses = txes.filter(
  (tx) =>
    tx.From.toLowerCase() ===
      "0x8ec7466a5025ac26368bd8b8cfd2571f9bc0dc6f".toLowerCase() &&
    tx.TokenSymbol === "UNI-V2"
);

const totalNapsWithdrawals = txes.filter(
  (tx) =>
    tx.From.toLowerCase() ===
      "0x8ec7466a5025ac26368bd8b8cfd2571f9bc0dc6f".toLowerCase() &&
    tx.TokenSymbol === "NAP"
);

const totalStakedUNI = totalStakedUNIForAddresses.reduce(
  (accumulator, currentValue) => {
    if (!accumulator[currentValue.From]) {
      accumulator[currentValue.From] = {
        address: currentValue.From.toLowerCase(),
        stakedUNI: currentValue.Value,
      };
    } else {
      accumulator[currentValue.From].stakedUNI =
        accumulator[currentValue.From].stakedUNI + currentValue.Value;
    }
    return accumulator;
  },
  {}
);

const totalWithdrawUNI = totalWithdrawUNIForAddresses.reduce(
  (accumulator, currentValue) => {
    if (!accumulator[currentValue.To]) {
      accumulator[currentValue.To] = {
        address: currentValue.To.toLowerCase(),
        stakedUNI: currentValue.Value,
      };
    } else {
      accumulator[currentValue.To].stakedUNI =
        accumulator[currentValue.To].stakedUNI + currentValue.Value;
    }
    return accumulator;
  },
  {}
);

const totalWithdrawNaps = totalNapsWithdrawals.reduce(
  (accumulator, currentValue) => {
    if (!accumulator[currentValue.To]) {
      accumulator[currentValue.To] = {
        address: currentValue.To.toLowerCase(),
        NAPSclaimed: currentValue.Value,
      };
    } else {
      accumulator[currentValue.To].NAPSclaimed =
        accumulator[currentValue.To].NAPSclaimed + currentValue.Value;
    }
    return accumulator;
  },
  {}
);

const results = {};

let totalUNIMIssing = 0;

for (const [address, staked] of Object.entries(totalStakedUNI)) {
  let totalStaked = staked.stakedUNI;
  let totalNAPSclaimed = totalWithdrawNaps[staked.address];
  if (totalWithdrawUNI[staked.address]) {
    results[address] = {};
    let totalWithdraw = totalWithdrawUNI[staked.address].stakedUNI;

    if (typeof totalWithdraw === "string") {
      totalWithdraw = parseFloat(totalWithdraw);
    }

    if (typeof totalStaked === "string") {
      totalStaked = parseFloat(totalStaked);
    }
    const totalBalance = totalStaked - totalWithdraw;
    if (totalBalance.toFixed(3) > 0.5) {
      totalUNIMIssing = totalBalance + totalUNIMIssing;
      results[address].UNIlost = totalBalance;
      results[address].NAPSclaimed = totalNAPSclaimed
        ? totalNAPSclaimed.NAPSclaimed
        : 0;
      results[address].totalStaked = totalStaked;
      results[address].totalWithdrawn = totalWithdraw;
    } else {
      delete results[address];
    }
  } else {
    results[address] = {};
    const totalBalance = totalStaked;
    totalUNIMIssing = totalBalance + totalUNIMIssing;
    results[address].UNIlost = totalStaked;
    results[address].NAPSclaimed = totalNAPSclaimed
      ? totalNAPSclaimed.NAPSclaimed
      : 0;
    results[address].totalStaked = totalStaked;
    results[address].totalWithdrawn = 0;
  }
}
let totalUNILost = 0;
let totalLostUSD = 0;

const UNI_VALUE_BEFORE_ERROR = 26.77;
const NAP_VALUE_BEFORE_ERROR = 0.55;
const TOTAL_NAP_VALUE_AFTER_ERROR = 0.15;

const TOTAL_NAP_CLAIMED_AFTER_ERROR = 480000 * TOTAL_NAP_VALUE_AFTER_ERROR;

Object.entries(results).forEach(([key, value]) => {
  if (Math.abs(value.UNIlost) > 0.1) {
    const totalUNIlostUSD = value.UNIlost * UNI_VALUE_BEFORE_ERROR;
    const totalNAPSgainUSD = value.NAPSclaimed * NAP_VALUE_BEFORE_ERROR;
    const totalUSDLostForAccount = totalUNIlostUSD - totalNAPSgainUSD;
    if (totalUSDLostForAccount <= 0 && !isNaN(totalUSDLostForAccount)) {
      delete results[key];
      return;
    }
    totalUNILost = totalUNILost + value.UNIlost;
    results[key].totalUSDLostForAccount = totalUSDLostForAccount;
    results[key].totalUNILost = totalUNILost;
    totalLostUSD = totalLostUSD + value.totalUSDLostForAccount;
    results[key].address = key.toLowerCase();
  } else {
    delete results[key];
  }
});

const TOTAL_USD_LOST_AFTER_CLAIMED_NAPS =
  totalLostUSD - TOTAL_NAP_CLAIMED_AFTER_ERROR;
const CLAIMED_NAP_REDUCE_MULTIPLIER =
  TOTAL_USD_LOST_AFTER_CLAIMED_NAPS / totalLostUSD;

Object.entries(results).forEach(([key, value]) => {
  const weightedPercent =
    ((value.totalUSDLostForAccount * CLAIMED_NAP_REDUCE_MULTIPLIER) /
      TOTAL_USD_LOST_AFTER_CLAIMED_NAPS) *
    100;
  results[key.toLowerCase()].weightedPercent = weightedPercent;
});

export default {
  totalUNILost,
  totalLostUSD,
  CLAIMED_NAP_REDUCE_MULTIPLIER,
  TOTAL_USD_LOST_AFTER_CLAIMED_NAPS,
  results,
};
